module.exports = __webpack_public_path__ + "img/logo.603cdd94.png";